import { merge } from '../helper';
import isEmptyObject from '../general/isEmpty/isEmptyObject';

import * as exButton from '../components/button';
import * as exElement from './element';
import * as exHeader from './header';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (panel)
    const elPanel = exElement.create({
        merge: defConfig,
        class: {
            new: 'panel',
        },
        style: {
            position: 'absolute',
            top: '3%',
            left: '43%',
            width: config.width,
            height: config.height,
        },
    });
    elements.element = elPanel;

    // ------------------------------------------------------------------------

    // Create element (header)
    const panelHeader = exHeader.create({
        merge: defConfig.header,
        class: {
            new: 'panel-header',
        },
        title: {
            class: {
                new: 'panel-title',
            },
        },
        tools: {
            class: {
                new: 'panel-tools',
            },
            right: true,
        },
    });
    elPanel.appendChild(panelHeader.element);
    elements.header = panelHeader.element;

    // ------------------------------------------------------------------------

    // Create element (body)
    const elPanelBody = exElement.create({
        merge: defConfig.body,
        class: {
            new: 'panel-body',
        },
    });
    elPanel.appendChild(elPanelBody);
    elements.body = elPanelBody;

    // ------------------------------------------------------------------------

    // If using panel footer
    if (!isEmptyObject(defConfig.footer)) {
        // Create element (footer)
        const elPanelFooter = exElement.create({
            merge: defConfig.footer,
            class: {
                new: 'panel-footer',
            },
        });
        elPanel.appendChild(elPanelFooter);
        elements.footer = elPanelFooter;
    }

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using close
    if (config.close !== false) {
        // Create element (panel close)
        const elPanelClose = exButton.create({
            tag: 'div',
            class: {
                new: 'panel-close',
            },
            icon: {
                type: 'fa-solid fa-times',
            },
            event: {
                click: function (): any {
                    // If using function close
                    if (typeof config.fnClose === 'function') {
                        // Function Close
                        config.fnClose.call(this, {
                            element: elements.element,
                        });
                    }
                    // Is default
                    else {
                        elements.element.remove();
                    }
                },
            },
        });
        elements.header.tools.right.appendChild(elPanelClose.element);
    }
}

// ----------------------------------------------------------------------------

export { create };
